<template>
  <!-- eslint-disable -->
  <div class="action-item">
    <div class="message-item__settings-wrapper">
      <div class="d-flex flex-column align-center">
        <v-text-field
          class="message-item__settings--delay panzoom-ignore w-full"
          v-model="node.delay"
          :label="'Delay'"
          persistent-placeholder
          :placeholder="'2000'"
          :disabled="node.human"></v-text-field>
        <v-text-field
          class="message-item__settings--cssclass panzoom-ignore w-full"
          v-model="node.cssClass"
          :label="'Class'"
          persistent-placeholder
          :placeholder="''"></v-text-field>
        <VaColorPicker
          class="mb-4 panzoom-ignore"
          :title="'Background color'"
          hide-alpha-slider
          v-model="node.backgroundColor"></VaColorPicker>
        <v-text-field
          class="message-item__settings--cssclass panzoom-ignore w-full"
          v-model="node.columns"
          :label="'Columns'"
          persistent-placeholder
          :rules="[v => /^[0-9]*$/.test(v) || 'Only numbers are allowed']"
          :placeholder="''"></v-text-field>
        <div class="animated-button">
          <div class="d-flex justify-space-between animated-button__header">
            <div class="animated-button__title">
              {{ $t("shortcodes.live_chat.enable_pulsing_buttons") }}
            </div>
            <v-switch
              v-model="node.animatedButton"
              color="primary"
              :ripple="false"
              hide-details
              inset></v-switch>
          </div>
        </div>
        <LiveChatFloatingText :node="node" />
      </div>
    </div>
  </div>
</template>

<script>
  import VaColorPicker from "@/components/custom/VaColorPicker";
  import LiveChatFloatingText from "./LiveChatFloatingText.vue";
  /* eslint-disable */
  export default {
    name: "LiveChatAction",
    components: { VaColorPicker, LiveChatFloatingText },
    props: {
      node: {
        type: Object,
        required: true,
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "@core/preset/preset/typography/index.scss";
  @import "@core/preset/preset/functions.scss";

  .animated-button {
    width: 100%;
    margin-top: 16px;
    background-color: get-color("primary-10-hover");
    border-radius: 6px;
    padding: 12px;
    box-sizing: border-box;
    text-align: left;

    &__header {
      align-items: center;

      &::v-deep {
        .v-input--selection-controls__input {
          margin-right: 0;
        }
      }
    }

    &__title {
      color: get-color("headline");
      @include text-body-2-bold();
    }
  }
</style>
